import Splide from "@splidejs/splide";
import * as Popper from "@popperjs/core";
import { Dropdown } from "bootstrap";

document.addEventListener("DOMContentLoaded", function () {
  const splideElement = document.querySelector(".employees-new");
  if (!splideElement) return;

  const splide = new Splide(splideElement as HTMLElement, {
    type: 'slide',
    perPage: 3,
    focus: 0,
    omitEnd: true,
    arrows: true,
    gap: '1.5rem',
    lazyload: 'nearby',
    breakpoints: {
      1200: {
        perPage: 2,
      },
      768: {
        perPage: 1,
        fixedWidth: '100%',
        gap: '0',   
        arrows: false,
      },
    }
  });

  splide.mount();

  const allSlides = Array.from(
    splideElement.querySelectorAll("li[data-location-id]")
  ) as HTMLElement[];

  // Function to hide matching dropdown item
  function hideMatchingDropdownItem(matchingId: string | null) {
    document.querySelectorAll('ul.dropdown-menu > li').forEach(li => {
      const anchor = li.querySelector('a[data-id]');
      if (!anchor) return;

      const id = anchor.getAttribute('data-id');
      if (id === matchingId) {
        li.classList.add('d-none');
      } else {
        li.classList.remove('d-none');
      }
    });
  }

  // Core filter logic, reusable
  function filterByLocationId(selectedId: string) {
    allSlides.forEach((slide) => {
      const ids = slide.dataset.locationId?.split(",").map(id => id.trim()) || [];
      const matches = ids.includes(selectedId);

      slide.classList.toggle("d-none", !matches);
      slide.classList.toggle("splide__slide", matches);
    });

    document.querySelectorAll(".nav-emp a").forEach(btn =>
      btn.classList.remove("active")
    );

    const activeLink = document.querySelector(`.nav-emp a[data-id="${selectedId}"]`);
    if (activeLink) activeLink.classList.add("active");

    hideMatchingDropdownItem(selectedId);
    
    
    // Refresh layout and reset to first slide
    splide.refresh();
    splide.Components.Pagination.destroy();
    splide.Components.Pagination.mount();
    splide.go(0);
  }

  //  Run initial filter (dropdown or pills)
  const pillsExist = document.querySelectorAll('.nav-emp a[data-target="location"]').length > 0;
  const dropdownButton = document.querySelector('.nav-emp button[data-target="location"]');


  // Bind dropdown selection
  const dropdownItems = document.querySelectorAll('.dropdown-item[data-target="location"]');
  dropdownItems.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();

      const selectedName = this.textContent?.trim();
      const selectedId = this.getAttribute('data-id');
      const button = document.querySelector('.nav-emp button');
      if (!button || !selectedId) return;

      button.textContent = selectedName!;
      button.setAttribute('data-id', selectedId);

      filterByLocationId(selectedId);
    });
  });

  // Bind pills click
  document.querySelectorAll(".nav-emp a").forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const selectedId = link.getAttribute("data-id");
      if (selectedId) {
        filterByLocationId(selectedId);
      }
    });
  });

  // Run initial filter on page load
  const pillsActive = document.querySelector('.nav-emp a.active');
  const dropdownButtonActive = document.querySelector('.nav-emp button[data-id]');

  let initialId: string | null = null;

  if (pillsActive) {
    initialId = pillsActive.getAttribute('data-id');
  } else if (dropdownButton) {
    initialId = dropdownButtonActive.getAttribute('data-id');
  }

  if (initialId) {
    filterByLocationId(initialId);
  }

  // open caption on touch displays
  document.querySelectorAll('figcaption .icon-info').forEach(icon => {
  icon.addEventListener('click', function (e) {
    e.stopPropagation(); // prevent bubbling to figure
    const figcaption = icon.closest('figcaption');
    if (figcaption) {
      figcaption.classList.add('show-mobile');
    }
  });
});

document.querySelectorAll('figcaption .icon-close').forEach(icon => {
  icon.addEventListener('click', function (e) {
    e.stopPropagation();
    const figcaption = icon.closest('figcaption');
    if (figcaption) {
      figcaption.classList.remove('show-mobile');
    }
  });
});
});
